import { TreeItemWithRecord, TreeItem, ItemType } from './item';
import { RecordLink } from '../../record-link/record-link';
import { DossierTree } from './tree';
import { find, each } from 'lodash';
import { SimpleItem } from './simple-item';
import { SimpleItemWithGroups } from './simple-item-with-groups';
import { Link } from '../link';



export class RootItem extends TreeItem implements TreeItemWithRecord {

  link: RecordLink;

  constructor(tree: DossierTree) {
    super(null, tree);

    let dossier = tree.dossier;
    let dossierModel = tree.dossierModel;

    each(dossierModel.targets, (target) => {

      // Root item
      if (target.link.is_root) {
        this.link = find<Link>(dossier.links, l => l.model.is_root) as RecordLink;
      }
      // Simple item (Only when the dossier exists)
      else if (dossier.id) {

        // With group support
        if (target.link.default_link_group) {
          let item = new SimpleItemWithGroups(target, this, tree);

          this.addChild(item);
        }
        else {
          let item = new SimpleItem(target, this, tree);

          this.addChild(item);
        }

      }
    });
  }

  get type(): ItemType {
    return 'ROOT';
  }

  get label(): string {
    return this.link.model.label;
  }
}